var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"navbar d-flex align-items-center",class:[_vm.layout]},[_c('logo',{staticClass:"mt-1",attrs:{"type":"full"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }